module.exports = __webpack_public_path__ + "img/form_filled_icon.cf9605f0.svg";